import { env } from "./environment.config";

export const getFileNameUrl = (filename) =>
  `${env.API_BASE_URL}/v1/files/${filename}`;
